import {
    GET_LIST,
    GET_MANY,
} from 'react-admin';
import queryString from 'query-string';

import { getApiUrlForResource } from '../services/apiUrlResolver';
import logger from '../utils/logger';
// Helper function to get API URL at request time - languages use states flag
const getApiUrl = () => getApiUrlForResource('states');

export const LANGUAGES_RESOURCE_NAME = "languages";

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case GET_LIST: 
            return { url: `${getApiUrl()}/${LANGUAGES_RESOURCE_NAME}` };
        case GET_MANY: {
            // logger.log("languages get many with requestParams => ", requestParams);
            const query = {                     
                filters: JSON.stringify({ id: requestParams.ids }),
            };
            // logger.log(`${getApiUrl()}/${LANGUAGES_RESOURCE_NAME}?${queryString.stringify(query)}`)
            return { url: `${getApiUrl()}/${LANGUAGES_RESOURCE_NAME}?${queryString.stringify(query)}` };
        }               
    
        default:
            throw new Error(`Unsupported fetch action type for "LANGUAGES" resource ${requestType}`);
    }
};

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    let { headers, json } = httpResponse;
    switch (requestType) {
        case GET_LIST:
            return {
                data: json,
                total: parseInt(headers.get('content-range')),
            };
        case GET_MANY:
            let roleIdsToGet = requestParams.ids;
            // logger.log("roles_provider handling ids => ", roleIdsToGet);
            // logger.log(LANGUAGES_RESOURCE_NAME, "response: ", json.filter(roleItem => roleIdsToGet.includes(roleItem.id)))
            return {
                data: json.filter(roleItem => roleIdsToGet.includes(roleItem.id))
            };            
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

export default {
    resource: LANGUAGES_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
};
